import { render, staticRenderFns } from "./PayrollDetails.vue?vue&type=template&id=503a3737&scoped=true&"
import script from "./PayrollDetails.vue?vue&type=script&lang=js&"
export * from "./PayrollDetails.vue?vue&type=script&lang=js&"
import style0 from "./PayrollDetails.vue?vue&type=style&index=0&id=503a3737&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503a3737",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('503a3737')) {
      api.createRecord('503a3737', component.options)
    } else {
      api.reload('503a3737', component.options)
    }
    module.hot.accept("./PayrollDetails.vue?vue&type=template&id=503a3737&scoped=true&", function () {
      api.rerender('503a3737', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Payroll/PayrollDetails.vue"
export default component.exports